/**
 * Role for admin-panel RBAC. Prefer `adminUserRole`; fall back to `adminUserDetails.role`
 * so UI stays correct when login stored details but omitted the dedicated role key.
 */
export function getAdminPanelRole() {
  if (typeof window === "undefined") return "";
  const direct = localStorage.getItem("adminUserRole");
  if (direct != null && String(direct).trim() !== "") {
    return String(direct).trim().toLowerCase();
  }
  try {
    const raw = localStorage.getItem("adminUserDetails");
    if (!raw) return "";
    const parsed = JSON.parse(raw);
    const r = parsed?.role;
    if (r == null) return "";
    return String(r).trim().toLowerCase();
  } catch {
    return "";
  }
}
